export default {"src":"/_next/static/media/hash-to-image.f1f6b209.svg","height":620,"width":620,"blurWidth":0,"blurHeight":0};